var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolsTech(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M9,20.8c-0.5-0.4-1.1-0.7-1.8-0.6c-0.6,0-1.2,0.3-1.6,0.8c-0.4,0.5-0.7,1.1-0.6,1.8c0,0.7,0.4,1.3,0.9,1.7 C6.4,24.9,7,25,7.6,25c0.7,0,1.3-0.3,1.7-0.8c0.2-0.3,0.4-0.7,0.5-1.1h14.7l-5,4.1h-3.6c-0.1-0.5-0.4-1-0.8-1.3 c-0.5-0.4-1.1-0.6-1.8-0.6c-0.6,0.1-1.2,0.4-1.6,0.9c-0.4,0.5-0.6,1.1-0.6,1.7c0.1,0.7,0.4,1.3,0.9,1.7c0.5,0.4,1.1,0.6,1.8,0.6 c0.6-0.1,1.2-0.4,1.6-0.9c0.2-0.3,0.4-0.6,0.5-1h4l6.3-5.2h10.7l-11.3,9.3H22c-0.1-0.5-0.4-1-0.8-1.4c-0.5-0.4-1.1-0.6-1.7-0.5 c-0.7,0-1.3,0.3-1.7,0.8c-0.4,0.5-0.6,1.2-0.5,1.8c0,0.6,0.3,1.2,0.8,1.6c0.1,0.1,0.1,0.1,0.2,0.1c1,0.8,2.5,0.6,3.2-0.4 c0.3-0.2,0.5-0.6,0.5-1h4L38.7,23H40V22h-4.4L24.3,11.7h-4c-0.1-0.4-0.2-0.7-0.5-1c-0.4-0.5-1-0.8-1.6-0.9c-0.7-0.1-1.3,0.2-1.8,0.6 c-0.5,0.4-0.8,1-0.8,1.6c-0.1,0.6,0.1,1.3,0.5,1.8c0.9,1,2.4,1.1,3.4,0.3c0.4-0.3,0.7-0.8,0.8-1.3h3.6L34,22H23.2l-5-5.2h-3.4 c-0.1-0.4-0.3-0.7-0.5-1c-0.9-1-2.4-1.1-3.4-0.3c-0.5,0.4-0.8,1-0.9,1.7c0,0.6,0.2,1.2,0.6,1.7c0,0,0,0,0,0c0.9,1,2.4,1.1,3.4,0.3 c0.4-0.3,0.7-0.8,0.8-1.3h3l3.8,4.2H9.8C9.7,21.5,9.4,21.1,9,20.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolsTech);
export default __webpack_public_path__ + "static/media/tools_tech.689f723efa56922dd9bd211b92c9e438.svg";
export { ForwardRef as ReactComponent };